import { render, staticRenderFns } from "./MusicSectionMenu.vue?vue&type=template&id=5b3a984d&scoped=true&"
import script from "./MusicSectionMenu.vue?vue&type=script&lang=js&"
export * from "./MusicSectionMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3a984d",
  null
  
)

export default component.exports